import { useQueryClient } from 'react-query';

import { AttachementTypeEnum } from './types';
import { useCandidateAttachFile } from './useCandidateAttachFile';

export const useAttachFile = (candidateId: string) => {
  const attachCandidateFile = useCandidateAttachFile();
  const queryClient = useQueryClient();

  const attachFile = (fileId: string, type: AttachementTypeEnum) => {
    attachCandidateFile.mutate(
      { queryParams: { id: candidateId }, data: { fileId: fileId, type } },
      {
        onSuccess: () => queryClient.invalidateQueries(`/candidates/${candidateId}`),
      }
    );
  };

  const attachGeneralFile = (fileId: string) => {
    attachFile(fileId, AttachementTypeEnum.OTHER);
  };

  const attachHrInterviewFile = (fileId: string) => {
    attachFile(fileId, AttachementTypeEnum.HR_INTERVIEW);
  };

  const attachTechnicalInterviewFile = (fileId: string) => {
    attachFile(fileId, AttachementTypeEnum.TECHNICAL_INTERVIEW);
  };

  return {
    attachGeneralFile,
    attachHrInterviewFile,
    attachTechnicalInterviewFile,
  };
};
